import appointment from './appointment';
import carDestination from './carDestination';
import coreApi from './coreApi';
import diagnosis from './diagnosis';
import eligibility from './eligibility';
import error from './error';
import global from './global';
import language from './language';
import location from './location';
import settings from './settings';
import machineMeta from './machineMeta';
import fnol from './fnol';
import rentalMission from './rentalMission';

export default {
  appointment,
  carDestination,
  coreApi,
  diagnosis,
  eligibility,
  error,
  global,
  language,
  location,
  settings,
  machineMeta,
  fnol,
  rentalMission,
};
